// pages/InactiveMasters.jsx
import React from 'react';
import MasterListBase from './MasterListBase';

const InactiveMasters = () => (
    <MasterListBase statusFilter="inactive" title="Inactive Masters" subtitle="Masters currently inactive" />
);

export default InactiveMasters;